import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const AvgSpendGuestReport = ({
  chartOptions,
  chartData,
  storess,
  chartRef,
  containerId,
}) => (
  <div ref={chartRef} id={containerId}>
    <div className="card p-4">
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>

    <div className="print-only-content">
      <h2>Report Details</h2>
      <div className="print-only-content">
        <div>
          <h3>Brand: Angels Pizza</h3>
          <h3>Store: {storess}</h3>
        </div>
      </div>

      <div style={{ fontSize: "20px" }}>
        <table className="table text-center">
          <thead>
            <tr className="d-flex">
              <th>Month</th>
              <th className="ms-5">Avg Spend</th>
              <th className="ms-5">Guest Count</th>
            </tr>
          </thead>
          <tbody>
            {chartData.labels.map((label, index) => (
              <tr className="d-flex" key={`${containerId}-${index}`}>
                <td>{label}</td>
                <td>{chartData.monthlyAverages[index].toFixed(2)}</td>
                <td>{chartData.monthlyCounts[index]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default AvgSpendGuestReport;
